export default __webpack_public_path__ + "static/media/frame-card-warmonger.7b9a26c8.png";